import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Select from "material-ui/Select";
import Input, { InputLabel } from "material-ui/Input";
import Checkbox from "material-ui/Checkbox";
import Icon from "material-ui/Icon";
import Menu, { MenuItem } from "material-ui/Menu";
import {
  FormControl,
  FormControlLabel,
  FormHelperText
} from "material-ui/Form";
import TextField from "material-ui/TextField";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Tabs, { Tab } from "material-ui/Tabs";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import {
  validateFormData,
  validateTargetData
} from "../../../../common/formtool";

import { ModalHeader, ModalContents, ModalFooter } from "../../modal";
import Targets from "../../../targets";
import WireMapCustCable from "../../../subtestsetting/wiremapcustcable";
class NewCustorg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      forceEnableDeviceTypes: "",
      allCountries: [],
      filteredCountries: [],
      editSaving: false,
      errors: {},
      ipvErrors: {},
      customer: {
        deviceupdaterepositoryname: "",
        name: "",
        contactfirstname: "",
        contactlastname: "",
        telephoneno: "",
        contactemail: "",
        address: "",
        city: "",
        state: "",
        country: "",
        zipcode: "",
        logo: "",
        logopath: "",
        language: "en-GB",
        chartmeasurement: "",
        chartlinestyle: "",
        enabled: true,
        wiremapdisplaypreference:
          props.container === "organisations"
            ? props.mode.includes("create")
              ? "568B"
              : props.customer && props.customer.wiremapdisplaypreference
              ? props.customer.wiremapdisplaypreference
              : "568B"
            : ""
      },
      customerTargets4: this.props.customerTargets4,
      customerTargets6: this.props.customerTargets6,
      uploadLogoEnabled: false,
      error: null,
      tabs:
        props.container === "customers"
          ? props.mode.includes("edit")
            ? [
                props.translate("cust_tab_details"),
                props.translate("cust_tab_ipv4"),
                props.translate("cust_tab_ipv6"),
                props.translate("cust_tab_wiremap")
              ]
            : [props.translate("cust_tab_details")]
          : [],
      tabPosition: 0,
      statesOfCountry: null,
      stateexists : false
    };
    this.onChange = this.onChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onUploadLogoChange = this.onUploadLogoChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.deleteTarget = this.deleteTarget.bind(this);
    this.addTarget = this.addTarget.bind(this);
    this.editTarget = this.editTarget.bind(this);
    this.onDisplayPrefChange = this.onDisplayPrefChange.bind(this);
  }

  componentWillMount() {
    this.props.reset();
  }

  // componentWillReceiveProps(nextProps) {

  //   const { customerTargets4, ipvErrors, customerTargets6 } = nextProps;
  //   if (customerTargets4 && this.props.customerTargets4 != customerTargets4) {
  //     this.setState({
  //       customerTargets4,
  //       ipvErrors
  //     });
  //   }
  //   if (customerTargets6 && this.props.customerTargets6 != customerTargets6) {
  //     this.setState({
  //       customerTargets6,
  //       ipvErrors
  //     });
  //   }
  // }

  componentWillReceiveProps(nextProps) {
    const { editSaving, allCountries, forceEnableDeviceTypes } = this.state;
    const {
      customer,
      customerTargets4,
      customerTargets6,
      cableList,
      wireMap,
      ipvErrors,
      configs
    } = nextProps;

    if (forceEnableDeviceTypes.length <= 0) {
      let searchString = "ForceEnableDeviceTypes=";
      let index = configs === null || configs === undefined ? -1 : configs.indexOf(searchString);
      if (index >= 0) {
        this.setState({forceEnableDeviceTypes: configs.substring(index + searchString.length)});
      }
    }
    if (allCountries.length <= 0) {
      this.setState({ allCountries: this.props.countryStates.countries, filteredCountries: this.props.countryStates.countries })
    }
    if ( customer && customer != this.props.customer && customer.country && this.props.countryStates) {
      let statesOfCountry = null;
      let countries = this.props.countryStates.countries.filter(c => c.countrycode == customer.country);
      let country = (countries && countries.length) ? countries[0] : "";
      let stateExists = country.stateexists;
      if (stateExists)
        statesOfCountry = this.props.countryStates.states.filter(s => s.countrycode == country.countrycode);
      this.setState({ stateexists : stateExists, statesOfCountry: statesOfCountry })
    }
    if (!editSaving) {
      if (customer) {
        this.setState({
          customer: { ...customer },
          customerTargets4: customerTargets4,
          customerTargets6: customerTargets6,
          cableList: cableList,
          wireMap: wireMap,
          ipvErrors
        });
        return;
      }
    }
    this.setState({
      customer: {
        ...this.state.customer,
        logo: customer ? customer.logo : null,
        logopath: customer ? customer.logopath : null
      },
      tabPosition: 0
    });
  }

  handleTabChange = (event, value) => {
    let { tabPosition } = this.state;
    if (tabPosition >= 0 && tabPosition <= 3)
      this.setState({ tabPosition: value });
  };

  filterCountriesList = (e) => {
    const key = e.key;
    let { allCountries } = this.state;
    let _filteredCountries = (key.length > 0) ? allCountries.filter(c => c.countryname.toLowerCase().startsWith(key.toLowerCase())) : allCountries;
    if (_filteredCountries.length <= 0 ) {
      _filteredCountries = allCountries;
    }
    else {
      allCountries.forEach(element => {
        if (!_filteredCountries.some(c => c.countrycode == element.countrycode)) {
          _filteredCountries.push(element);
        }
      });
    }
    this.setState({ filteredCountries: _filteredCountries });
    // scroll to the top of the list
    setTimeout(() => {
      let menutop = document.getElementById('menutop');
      if (menutop) {
        menutop.scrollIntoView({ behavior: "smooth" });
        menutop.checked = true;
      }
    }, 100);
  }

  onCloseCountries() {
    setTimeout(() => {
      let { allCountries } = this.state;
      this.setState({ filteredCountries: allCountries });
    }, 500);
  }

  onChange(e) {
    let { filteredCountries } = this.state;
    let customer = { ...this.state.customer };
    let countryStates= { ...this.props.countryStates}
    if (e.target.name === 'country') {
      let country = filteredCountries.filter(c => c.countrycode == e.target.value)[0];
      if (country.stateexists) {
        let statesList = countryStates.states.filter(s => s.countrycode == country.countrycode);
        this.setState({statesOfCountry :statesList })
        }
      if(customer.country != e.target.value)
        customer= {...customer, state: "" }
      this.setState({ stateexists: country.stateexists? true: false });
    }
    customer[e.target.name] = e.target.value;

    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    if (e.target.name === "name") {
      delete errors["validCustOrgName"];
    }
    this.setState({ customer: customer, errors });
  }

  onDisplayPrefChange(e) {
    let customer = { ...this.state.customer };
    customer[e.target.name] = e.target.value;
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    this.setState({ customer: customer, errors });
  }

  handleClose() {
    this.props.close(!this.state.uploadLogoEnabled);
  }

  onUploadLogoChange(e) {
    this.setState({
      uploadLogoEnabled: e.target.checked
    });
  }

  handleSubmit() {
    this.setState({
      errors: {}
    });
    switch (this.state.tabPosition) {
      case 0:
        this.CustDetailsSubmit();
        break;
      case 1:
        this.IPV4TargetsSubmit();
        break;
      case 2:
        this.IPV6TargetsSubmit();
        break;
      default:
        return null;
    }
  }
  IPV4TargetsSubmit() {
    //const { selectedTest } = this.state;
    const { translate } = this.props;
    let vObj2 = {};
    let ipvErrors;

    this.state.customerTargets4.forEach(function(item, index) {
      vObj2[index] = {
        required: translate("formfield_error_general_required"),
        maxLength: {
          value: 256,
          message: translate("subtest_target_length_validation", {
            value: 256
          })
        }
      };
    });
    ipvErrors = validateTargetData(this.state.customerTargets4, vObj2, "ipv4");
    if (Object.keys(ipvErrors).length) {
      this.setState({ ipvErrors: ipvErrors });
    } else {
      let self = this;
      this.props.updateCustTargets4(
        this.state.customer.id,
        this.state.customerTargets4
      );
      this.setState({ isUpdated: false });
    }
  }
  IPV6TargetsSubmit() {
    const { translate } = this.props;
    let vObj2 = {};
    let ipvErrors;

    this.state.customerTargets6.forEach(function(item, index) {
      vObj2[index] = {
        required: translate("formfield_error_general_required"),
        maxLength: {
          value: 256,
          message: translate("subtest_target_length_validation", {
            value: 256
          })
        }
      };
    });
    ipvErrors = validateTargetData(this.state.customerTargets6, vObj2, "ipv6");
    if (Object.keys(ipvErrors).length) {
      this.setState({ ipvErrors: ipvErrors });
    } else {
      let self = this;
      this.props.updateCustTargets6(
        this.state.customer.id,
        this.state.customerTargets6
      );

      this.setState({ isUpdated: false });
    }
  }

  CustDetailsSubmit() {
    let {
      translate,
      mode,
      pager,
      create,
      update,
      addLogo,
      removedSelectedRadioCheck
    } = this.props;
    let customer = { ...this.state.customer };
    let validationObj = {}
    if (this.props.container === "customers") {
      validationObj = {
        name: {
          required: translate("formfield_error_general_required")
        },
        validCustOrgName: {
          maxLength: {
            value: 63,
            message: translate("orgcust_name_not_valid")
          }
        },
        contactemail: {
          validEmail: this.state.customer.contactemail && this.state.customer.contactemail.length > 0 && translate("user_email_error")
        },
      };
    }
    else {
      validationObj = {
        name: {
          required: translate("formfield_error_general_required")
        },
        validCustOrgName: {
          maxLength: {
            value: 63,
            message: translate("orgcust_name_not_valid")
          }
        },
        contactfirstname: {
          required: translate("formfield_error_general_required")
        },
        contactlastname: {
          required: translate("formfield_error_general_required")
        },
        telephoneno: {
          required: translate("formfield_error_general_required")
        },
        contactemail: {
          required: translate("formfield_error_general_required"),
          validEmail: translate("user_email_error")
        },
        country: {
          required: translate("formfield_error_general_required")
        },
        state: {
          required: this.state.stateexists && !this.state.customer.state && translate("formfield_error_general_required")
        }
      };
    }

    if (this.props.container !== "customers") {
      validationObj.chartmeasurement = {
        required: translate("formfield_error_general_required")
      };
      validationObj.chartlinestyle = {
        required: translate("formfield_error_general_required")
      };
      validationObj.wiremapdisplaypreference = {
        required: translate("formfield_error_general_required")
      };
    }

    let errors = validateFormData(
      { ...this.state.customer, validCustOrgName: this.state.customer.name },
      validationObj
    );
    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }
    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
    } else {
      let self = this;
      let email = this.state.customer.contactemail;
      let name = this.state.customer.name;
      if (mode === "edit") {
        this.setState(
          {
            editSaving: true
          },
          () => {
            update(this.state.customer, pager)
              .then(resp => {
                self.handleClose();
                self.props.removedSelectedRadioCheck();
              })
              .catch(err => {
                //error_customerexists comes for Customer
                if (err.errors === "error_customerexists") {
                  self.setState({
                    error: {
                      type: "error_duplicatecustomer",
                      data: name
                    }
                  });
                }
                //error_organisationexists comes for Organisation
                if (err.errors === "error_organisationexists") {
                  self.setState({
                    error: {
                      type: "error_duplicateorganisation",
                      data: name
                    }
                  });
                }
                //error_duplicateuser comes for Organisation
                if (err.errors === "error_duplicateuser") {
                  self.setState({
                    error: {
                      type: "error_duplicateuser",
                      data: email
                    }
                  });
                }
              });
          }
        );
      } else {
        create(customer, pager)
          .then(resp => {
            if (self.state.uploadLogoEnabled) {
              addLogo();
            }
            self.handleClose();
          })
          .catch(err => {
            //error_customerexists comes for Customer
            if (err.errors === "error_customerexists") {
              self.setState({
                error: {
                  type: "error_duplicatecustomer",
                  data: name
                }
              });
            }
            //error_organisationexists comes for Organisation
            if (err.errors === "error_organisationexists") {
              self.setState({
                error: {
                  type: "error_duplicateorganisation",
                  data: name
                }
              });
            }
            //error_duplicateuser comes for Organisation
            if (err.errors === "error_duplicateuser") {
              self.setState({
                error: {
                  type: "error_duplicateuser",
                  data: email
                }
              });
            }
          });
      }
    }
  }

  getTitle() {
    if (this.props.container === "customers") {
      if (this.props.mode === "edit") {
        return this.props.translate("edit_customer");
      } else {
        return this.props.translate("add_customer");
      }
    } else {
      if (this.props.mode === "edit") {
        return this.props.translate("edit_organisation");
      } else {
        return this.props.translate("add_organisation");
      }
    }
  }

  removeLogo = id => {
    this.setState(
      {
        customer: {
          ...this.state.customer,
          logo: null,
          logopath: null
        },
        editSaving: true
      },
      () => {
        this.props.removeLogo(id);
      }
    );
  };

  getLogo() {
    const { classes, mode, addLogo } = this.props;
    const customer = this.state.customer;
    if (mode === "edit") {
      if (customer.logo) {
        return (
          <Grid item>
            <img alt="" src={customer.logo} className={classes.logo} />
            <Button
              fab
              mini
              color="primary"
              className={`${classes.logoButton} ${classes.logoButtonRemove}`}
              onClick={() => this.removeLogo(customer.id)}
              aria-label="remove"
            >
              <Icon className={classes.logoButtonIcon}>remove</Icon>
            </Button>
          </Grid>
        );
      } else {
        return (
          <Grid item>
            <div className={classes.LogoMissing}></div>
            <Button
              fab
              mini
              color="primary"
              className={`${classes.logoButton} ${classes.logoButtonAdd}`}
              onClick={() => addLogo()}
              aria-label="add"
            >
              <Icon className={classes.logoButtonIcon}>add</Icon>
            </Button>
          </Grid>
        );
      }
    } else {
      return null;
    }
  }
  getModalError(error) {
    const { translate, classes } = this.props;
    if (error.type === "error_duplicatecustomer") {
      return (
        <div className={classes.error}>
          <Typography type="subheading" color="inherit">
            {translate("error_duplicatecustomer_title")}
          </Typography>
          <Typography type="body1" color="inherit">
            {translate("error_duplicatecustomer_desc", { name: error.data })}
          </Typography>
        </div>
      );
    }
    if (error.type === "error_duplicateorganisation") {
      return (
        <div className={classes.error}>
          <Typography type="subheading" color="inherit">
            {translate("error_duplicateorganisation_title")}
          </Typography>
          <Typography type="body1" color="inherit">
            {translate("error_duplicateorganisation_desc", { name: error.data })}
          </Typography>
        </div>
      );
    }
    if (error.type === "error_duplicateuser") {
      return (
        <div className={classes.error}>
          <Typography type="subheading" color="inherit">
            {translate("error_duplicateuser_title")}
          </Typography>
          <Typography type="body1" color="inherit">
            {translate("error_duplicateuser_desc", { email: error.data })}
          </Typography>
        </div>
      );
    }
  }

  deleteTarget = deleteTargetKey => {
    if (this.state.tabPosition == 1) {
      // let customerTargets4 = this.state.customerTargets4.filter(
      //   item => item.id != deleteTargetKey
      // );
      let customerTargets4 = this.state.customerTargets4;
      customerTargets4.splice(deleteTargetKey, 1);
      this.setState({
        customerTargets4,
        isChanged: true,
        ipvErrors: {}
      });
    } else {
      // let customerTargets6 = this.state.customerTargets6.filter(
      //   item => item.id != deleteTargetKey
      // );
      let customerTargets6 = this.state.customerTargets6;
      customerTargets6.splice(deleteTargetKey, 1);
      this.setState({
        customerTargets6,
        isChanged: true,
        ipvErrors: {}
      });
    }
  };

  addTarget = (key, deleteTargetId) => {
    if (this.state.tabPosition == 1) {
      let customerTargets4 = this.state.customerTargets4;
      customerTargets4.push({ url: null });
      this.setState({
        customerTargets4,
        isChanged: true,
        ipvErrors: {}
      });
    } else {
      let customerTargets6 = this.state.customerTargets6;
      customerTargets6.push({ url: null });
      this.setState({
        customerTargets6,
        isChanged: true,
        ipvErrors: {}
      });
    }
  };

  editTarget = (value, key, id) => {
    let ipvErrors = { ...this.state.ipvErrors };

    if (this.state.tabPosition == 1) {
      let customerTargets4 = [...this.state.customerTargets4];
      customerTargets4[key].url = value;
      ipvErrors = {
        ...ipvErrors,
        [key]: false
      };
      this.setState({
        customerTargets4,
        isChanged: true,
        ipvErrors
      });
    } else {
      let customerTargets6 = [...this.state.customerTargets6];
      customerTargets6[key].url = value;
      ipvErrors = {
        ...ipvErrors,
        [key]: false
      };
      this.setState({
        customerTargets6,
        isChanged: true,
        ipvErrors
      });
    }
  };

  render() {
    const {
      classes,
      languages,
      container,
      modal,
      mode,
      translate,
      getWireMap,
      getCableList,
      updateCableList,
      DeleteCable,
      allRepositories,
      configs,
      smartFlagProfiles
    } = this.props;

    const {
      customer,
      errors,
      error,
      tabs,
      tabPosition,
      customerTargets4,
      customerTargets6,
      cableList,
      wireMap,
      ipvErrors,
      stateexists,
      statesOfCountry,
      filteredCountries,
      forceEnableDeviceTypes
    } = this.state;

    return (
      <Modal open={modal} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Grid
                container
                alignItems="center"
                direction="row"
                justify="flex-start"
              >
                {this.getLogo()}
                <Grid item>
                  <Typography
                    type="headline"
                    color="inherit"
                    className={classes.modalHeader}
                  >
                    {this.getTitle()}
                  </Typography>
                </Grid>
              </Grid>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>

            <ModalContents>
              {error && this.getModalError(error)}
              <form noValidate autoComplete="off" className={classes.form}>
                {container === "organisations" && (
                  <FormControl className={classes.textField} margin="normal">
                    <InputLabel htmlFor="language">
                      {translate("general_language")}
                    </InputLabel>
                    <Select
                      value={customer.language}
                      onChange={this.onChange}
                      input={
                        <Input
                          name="language"
                          id="language"
                          value={customer.language}
                        />
                      }
                      autoWidth={false}
                    >
                      {languages.map((language, index) => {
                        return (
                          <MenuItem key={index} value={language.code}>
                            {language.code}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <FormHelperText>{translate("set_language")}</FormHelperText>
                  </FormControl>
                )}

                {container === "organisations" && forceEnableDeviceTypes.length > 0 && (
                  <FormControl className={classes.textField} margin="normal">
                    <TextField
                      error={errors.enabledevicetypes}
                      name="enabledevicetypes"
                      label={"Enable Device Types"}
                      margin="normal"
                      fullWidth
                      value={customer.enabledevicetypes ? customer.enabledevicetypes : ""}
                      onChange={this.onChange}
                      helperText={"Enter comma separated list of these device types: " + forceEnableDeviceTypes}
                    />
                  </FormControl>
                )}

                {container === "organisations" && (
                  <FormControl className={classes.textField} margin="normal">
                    <InputLabel>
                      Repository
                    </InputLabel>
                    <Select
                      className={classes.select}
                      value={customer.deviceupdaterepositoryname}
                      onChange={this.onChange}
                      input={
                        <Input
                          name="deviceupdaterepositoryname"
                          id="deviceupdaterepositoryname"
                          value={customer.deviceupdaterepositoryname}
                        />
                      }
                    >
                      {allRepositories.map((repo, index) => {
                        return (
                          <MenuItem key={index} value={repo.name}>
                            {repo.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <FormHelperText>Assign the software update repository</FormHelperText>
                  </FormControl>
                )}

                {tabs && tabs.length > 0 ? (
                  <Tabs value={tabPosition} onChange={this.handleTabChange}>
                    {tabs.map((tab, index) => {
                      return <Tab key={index} label={tab} />;
                    })}
                  </Tabs>
                ) : null}
                {tabPosition === 0 && (
                  <div>
                    <TextField
                      error={errors.name || errors.validCustOrgName}
                      required
                      name="name"
                      label={
                        container === "customers"
                          ? translate("customer_name")
                          : translate("organisation_name")
                      }
                      margin="normal"
                      fullWidth
                      value={customer.name ? customer.name : ""}
                      onChange={this.onChange}
                      helperText={
                        !errors.validCustOrgName
                          ? container === "customers"
                            ? translate("customer_name_help")
                            : translate("organisation_name_help")
                          : translate("orgcust_name_not_valid")
                      }
                    />

                    <TextField
                      className={classes.textField}
                      error={errors.contactfirstname}
                      required={container !== "customers"}
                      name="contactfirstname"
                      label={translate("contactfirstname")}
                      margin="normal"
                      value={
                        customer.contactfirstname
                          ? customer.contactfirstname
                          : ""
                      }
                      onChange={this.onChange}
                      helperText={translate("customer_contact_first_name_help")}
                    />

                    <TextField
                      className={classes.textField}
                      error={errors.contactlastname}
                      required={container !== "customers"}
                      name="contactlastname"
                      label={translate("contactlastname")}
                      margin="normal"
                      value={
                        customer.contactlastname ? customer.contactlastname : ""
                      }
                      onChange={this.onChange}
                      helperText={translate("customer_contact_last_name_help")}
                    />

                    <TextField
                      className={classes.textField}
                      error={errors.telephoneno}
                      required={container !== "customers"}
                      name="telephoneno"
                      label={translate("customer_contact")}
                      margin="normal"
                      value={customer.telephoneno ? customer.telephoneno : ""}
                      onChange={this.onChange}
                      helperText={translate("customer_contact_help")}
                    />

                    <TextField
                      className={classes.textField}
                      error={errors.contactemail}
                      required={container !== "customers"}
                      name="contactemail"
                      label={translate("customer_email")}
                      margin="normal"
                      value={customer.contactemail ? customer.contactemail : ""}
                      onChange={this.onChange}
                      helperText={translate("customer_email_help")}
                    />

                    <TextField
                      error={errors.address}
                      name="address"
                      label={translate("customer_address")}
                      margin="normal"
                      fullWidth
                      value={customer.address ? customer.address : ""}
                      onChange={this.onChange}
                      helperText={translate("customer_address_help")}
                    />

                    <TextField
                      error={errors.city}
                      name="city"
                      label={translate("customer_city")}
                      margin="normal"
                      fullWidth
                      value={customer.city ? customer.city : ""}
                      onChange={this.onChange}
                      helperText={translate("customer_city_help")}
                    />

                    <FormControl
                      fullWidth
                      required={container !== "customers"}
                      margin="normal"
                      error={ errors.country }
                    >
                      <InputLabel >  { translate("customer_country") }   </InputLabel>
                      <Select
                        error={ errors.country }
                        value={ customer.country ? customer.country : "" }
                        input={
                        <Input
                          name="country"
                          id="country"
                          onChange={ this.onChange }
                          value={ customer.country }

                        />
                        }
                        MenuProps={{
                          onBlur:() => {
                            this.onCloseCountries();
                          },
                          onKeyPress:(e) => {
                            this.filterCountriesList(e);
                          }
                        }}
                        autoWidth={ false }
                      >
                      {
                         filteredCountries.map((country, index) => {
                          if (index == 0) {
                            return (
                              <MenuItem id='menutop' value={ country.countrycode }>
                                { country.countryname }
                              </MenuItem>
                            );
                          }
                          return (
                            <MenuItem value={ country.countrycode }>
                              { country.countryname }
                            </MenuItem>
                          );
                        })
                      }
                      </Select>
                      <FormHelperText>
                        { translate("customer_country_help") }
                      </FormHelperText>
                    </FormControl>

                    {(!stateexists || statesOfCountry.length ==  0) ?
                    <TextField
                      error={ errors.state }
                      name="state"
                      label={ translate("customer_state_county") }
                      margin="normal"
                      fullWidth
                      value={ customer.state? customer.state: ""}
                      onChange={ this.onChange }
                      helperText={ translate("customer_state_county_help") }
                    />
                    :
                    (<FormControl
                      fullWidth
                      required={container !== "customers"}
                      margin="normal"
                      error={ errors.state }
                    >

                      <InputLabel > {translate("customer_state_county")}  </InputLabel>
                      <Select
                        error={ errors.state }
                        value={ customer.state ? customer.state : "" }
                        input={
                          <Input
                            name="state"
                            id="state"
                            onChange={ this.onChange }
                            value={ customer.state }

                          />
                        }
                        autoWidth={ false }
                      >
                        { statesOfCountry.map((state) => {
                          return (
                            <MenuItem value={ state.statecode }>
                              {state.statename }
                            </MenuItem>
                          );
                        }) }
                      </Select>
                      <FormHelperText>
                        { translate("customer_state_county_help") }
                      </FormHelperText>
                    </FormControl>
                    ) }

                    {/* <TextField
                      error={errors.country}
                      required
                      name="country"
                      label={translate("customer_country")}
                      margin="normal"
                      fullWidth
                      value={customer.country ? customer.country : ""}
                      onChange={this.onChange}
                      helperText={translate("customer_country_help")}
                    />*/}

                    <TextField
                      error={errors.zipcode}
                      name="zipcode"
                      label={translate("customer_zipcode")}
                      margin="normal"
                      fullWidth
                      value={customer.zipcode ? customer.zipcode : ""}
                      onChange={this.onChange}
                      helperText={translate("customer_zipcode_help")}
                    />

                    {container === "customers" && this.props.activeFeatures?.some(f => f.featureName === 'smart_flag') && (
                      <FormControl
                        fullWidth
                        margin="normal"
                      >
                        <InputLabel htmlFor="smartFlagProfileId">
                          {translate("customer_smart_flag_profile")}
                        </InputLabel>
                        <Select
                          value={customer.smartFlagProfileId ? customer.smartFlagProfileId : ""}
                          onChange={this.onChange}
                          input={
                            <Input
                              name="smartFlagProfileId"
                              id="smartFlagProfileId"
                              value={customer.smartFlagProfileId}
                            />
                          }
                          autoWidth={false}
                        >
                          <MenuItem value={""}>
                            {translate("customer_smart_flag_use_org_default")}
                          </MenuItem>
                          {smartFlagProfiles && smartFlagProfiles.map((profile) => (
                            <MenuItem key={profile.id} value={profile.id}>
                              {profile.name}{profile.isDefault ? ` (${translate("customer_smart_flag_default")})` : ""}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {translate("customer_smart_flag_profile_help")}
                        </FormHelperText>
                      </FormControl>
                    )}
                  </div>
                )}
                {tabPosition === 1 && (
                  <Targets
                    translate={translate}
                    customerTargets={customerTargets4}
                    deleteTarget={this.deleteTarget}
                    addTarget={this.addTarget}
                    editTarget={this.editTarget}
                    selectedTest={"ipv4"}
                    isEditCustomer="true"
                    ipvErrors={ipvErrors}
                  />
                )}
                {tabPosition === 2 && (
                  <Targets
                    translate={translate}
                    customerTargets={customerTargets6}
                    deleteTarget={this.deleteTarget}
                    addTarget={this.addTarget}
                    editTarget={this.editTarget}
                    selectedTest={"ipv6"}
                    isEditCustomer="true"
                    ipvErrors={ipvErrors}
                  />
                )}
                {tabPosition === 3 && (
                  <WireMapCustCable
                    translate={this.props.translate}
                    getWireMap={getWireMap}
                    wireMap={wireMap}
                    getCableList={getCableList}
                    cableList={cableList}
                    updateCableList={updateCableList}
                    DeleteCable={DeleteCable}
                    isEditCustomer="true"
                    customerId={customer.id}
                  />
                )}
                {container !== "customers" && (
                  <FormControl
                    fullWidth
                    required
                    margin="normal"
                    error={errors.chartmeasurement ? true : false}
                  >
                    <InputLabel htmlFor="chartmeasurement">
                      {translate("customer_chartmeasurement")}
                    </InputLabel>
                    <Select
                      value={customer.chartmeasurement}
                      onChange={this.onChange}
                      input={
                        <Input
                          name="chartmeasurement"
                          id="chartmeasurement"
                          value={customer.chartmeasurement}
                        />
                      }
                      autoWidth={false}
                    >
                      <MenuItem value={"Feet"}>
                        {translate("customer_chart_feet")}
                      </MenuItem>
                      <MenuItem value={"Meters"}>
                        {translate("customer_chart_meter")}
                      </MenuItem>
                    </Select>
                    <FormHelperText>
                      {translate("customer_chartmeasurement_help")}
                    </FormHelperText>
                  </FormControl>
                )}
                {container !== "customers" && (
                  <FormControl
                    fullWidth
                    required
                    margin="normal"
                    error={errors.chartlinestyle ? true : false}
                  >
                    <InputLabel htmlFor="chartlinestyle">
                      {translate("customer_chartlinestyle")}
                    </InputLabel>
                    <Select
                      value={customer.chartlinestyle}
                      onChange={this.onChange}
                      input={
                        <Input
                          name="chartlinestyle"
                          id="chartlinestyle"
                          value={customer.chartlinestyle}
                        />
                      }
                      autoWidth={false}
                    >
                      <MenuItem value={"Standard"}>
                        {translate("customer_chart_standard")}
                      </MenuItem>
                      <MenuItem value={"Inverted"}>
                        {translate("customer_chart_inverted")}
                      </MenuItem>
                    </Select>
                    <FormHelperText>
                      {translate("customer_chartlinestyle_help")}
                    </FormHelperText>
                  </FormControl>
                )}

                {container !== "customers" && (
                  <FormControl
                    fullWidth
                    required
                    margin="normal"
                    error={errors.wiremapdisplaypreference ? true : false}
                  >
                    <InputLabel htmlFor="wiremapdisplaypreference">
                      {translate("organisation_wiremap_display_pref")}
                    </InputLabel>
                    <Select
                      value={customer.wiremapdisplaypreference}
                      onChange={this.onDisplayPrefChange}
                      input={
                        <Input
                          name="wiremapdisplaypreference"
                          id="wiremapdisplaypreference"
                          value={customer.wiremapdisplaypreference}
                        />
                      }
                      autoWidth={false}
                    >
                      <MenuItem value={"Standard"}>
                        {translate("chart_line_standard")}
                      </MenuItem>
                      <MenuItem value={"568A"}>{translate("568-A")}</MenuItem>
                      <MenuItem value={"568B"}>{translate("568-B")}</MenuItem>
                      <MenuItem value={"TERA"}>{translate("TERA")}</MenuItem>
                    </Select>
                    <FormHelperText>
                      {translate("organisation_wiremap_display_pref_help")}
                    </FormHelperText>
                  </FormControl>
                )}

                {mode !== "edit" && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.uploadLogoEnabled}
                        onChange={e => this.onUploadLogoChange(e)}
                        value="uploadLogoEnabled"
                        color="primary"
                      />
                    }
                    label={translate("customer_ask_logo")}
                  />
                )}
              </form>
            </ModalContents>

            <ModalFooter>
              {tabPosition != 3 && (
                <Button
                  raised
                  color="primary"
                  className={classes.submit}
                  onClick={this.handleSubmit}
                  type="submit"
                >
                  {this.state.uploadLogoEnabled
                    ? translate("general_continue")
                    : translate("general_submit")}
                </Button>
              )}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    );
  }
}

export default withStyles(styles)(NewCustorg);
